import React, { forwardRef, useImperativeHandle, useEffect } from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import 'src/asset/scss/plugin/modalPopup.scss';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useUploadFileHook from 'src/webapp/hooks/comn/uploadFile.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
//comp
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목
import ImgArea from 'src/webapp/views/component/ImgArea';//브랜드로고이미지


const ItemIndex = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({//상위컴포넌트에서 호출
        uploadBrandImageAPI
    }));
    //store
    const { admin } = useAdminStore();
    const { inputRef, data } = props;//props
    //axios
    const { axiosMultiPartHandler } = useAxiosHook();//axios
    //hooks
    const { setOnMessageHandler } = useComnHook();//submitPopup메세지처리
    //파일추가
    const { files, setFiles//fileuseState
        , MAX_COUNT//최대업로드갯수
        , addFilesHandler//파일업로드핸들러
    } = useUploadFileHook();
    useEffect(() => {
        MAX_COUNT.current = 2;
    }, []);

    /* ==================== 이미지파일업로드 ==================== */
    //이미지파일업로드API
    const uploadBrandImageAPI = async (brandCd, type) => {
        const msgType = type === 1 ? '등록이' : type === 2 ? '수정이' : null;
        if(files.length <= 0) { setOnMessageHandler(1, (msgType + ' 성공적으로 처리되었습니다.')); return true; }
        for(let i = 0; i < files.length; i++) {
            const DATA = new FormData();
            const TYPE = i === 0 ? 1 : 4;
            let variables = { BRAND_CD:brandCd , IMG_CD:brandCd, TYPE:TYPE, LAST_UPDATE_USER:admin.COMN_ID, SUBMIT_TYPE:type };
            //for (let i = 0; i < files.length; i++) { DATA.append('file', files[i].file); }
            DATA.append('file', files[i].file);
            DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
            const result = await axiosMultiPartHandler(`brandImgRegAndUpdateForJson.do`, DATA);
            if(!result) { return false; }
            if(result.message !== "SUCCESS") { return false; }
            if(result.message === "SUCCESS") { setOnMessageHandler(1, (msgType + ' 성공적으로 처리되었습니다.')); return true; }
        }
    }
    /* ==================== 이미지파일업로드 ==================== */
    /* ==================== validateCheck ==================== */
    const onValidateHandler = () => {
        for(let i = 0; i < inputRef.current.length; i++) {
            if(inputRef.current[i].value.length <= 0) { props.onValid(null, true); return; } 
        }
        if(data === null && files.length <= (MAX_COUNT.current - 1)) { props.onValid(null, true); return; }
        props.onValid(null, false);
    }
    useEffect(() => {
        onValidateHandler();
    }, [files]);
    /* ==================== validateCheck ==================== */

    return ( 
        <div className="popupFormArea">
            <FormWrapper>
                <TitleWrapper title={'제조사(브랜드) - 한글'}/>
                <div className="textArea">
                    <input onChange={(e) => onValidateHandler()}
                        ref={el => (inputRef.current[0] = el)}
                        type="text" inputMode="text" placeholder="내용을 입력해주세요." defaultValue={data !== null ? data.BRAND_KOR_NAME : null} />
                </div>
            </FormWrapper>
            <FormWrapper>
                <TitleWrapper title={'제조사(브랜드) - 영문'}/>
                <div className="textArea">
                    <input onChange={(e) => onValidateHandler()}
                        ref={el => (inputRef.current[1] = el)}
                        type="text" inputMode="text" placeholder="내용을 입력해주세요." defaultValue={data !== null ? data.BRAND_ENG_NAME : null} />
                </div>
            </FormWrapper>
            {data !== null && data.IMG_SRC !== undefined? 
                <FormWrapper><TitleWrapper title={'현재 이미지'} />
                    <div className="imgPreview">
                        <div className="previewImage"><ImgArea src={`brand/logo/org` + data.IMG_SRC} alt={data.BRAND_KOR_NAME} />  </div>
                        <label>{data.BRAND_KOR_NAME + '.webp'}</label>
                    </div>
                    <div className="imgPreview">
                        <div className="previewImage"><ImgArea src={`brand/logo/gray` + data.IMG_SRC} alt={data.BRAND_KOR_NAME} />  </div>
                        <label>{data.BRAND_KOR_NAME + '.webp'}</label>
                    </div>
                </FormWrapper>
            : null}
            <FormWrapper><TitleWrapper title={'제조사(브랜드) 이미지 *컬러 > 흑백 순'}/>
                {files.length < MAX_COUNT.current ? 
                    <div className="fileArea">
                        <label htmlFor="file"><span>이미지 업로드</span><FontAwesomeIcon icon="fa-light fa-square-dashed-circle-plus" /></label> 
                        <input onChange={(e) => addFilesHandler(e)}
                            type="file" id="file" accept='image/webp' multiple />
                    </div>    
                : null}
                {files.length > 0 && files.map((file, idx) => (
                    <div key={file.id} className="imgPreview">
                        <button onClick={(e) => setFiles([])}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                        <div className="previewImage"><img src={file.url} alt="preview-img" /></div>
                        <label>{file.id}</label>
                    </div>
                ))}
            </FormWrapper>
        </div>
    );
})
export default ItemIndex;